import React, { useEffect, useState} from "react";
import { RCCAlert, RCCButton, RCCGrid,  RCCTooltip } from "react-common-components";
import { useFieldArray } from "react-hook-form";
import DateTimePicker from "src/components/DateTimePicker";
import LovUsers from "src/components/Lov/Users";
import { useTranslation } from "src/context/Translations/context";
import { ITabOccurenceSteps } from "../../../interface";


const TabSteps : React.FC<ITabOccurenceSteps> = ({
	occurrenceSteps,
	control,
	error, 
	disabled,
	isCopy
}) => {
 
	const { translate } = useTranslation();

	const [disabledLastItem, setDisabledLastItem] = useState(false);

	const { 
		fields, 
		remove,
		append
	} = useFieldArray({
		control,
		name: "octbb002",
		shouldUnregister: true
	});

	useEffect(() => {
		remove();
		if(occurrenceSteps)
			append(occurrenceSteps);
	}, [occurrenceSteps]);

	useEffect(() => {

		const itensFiltered = fields.filter((item: any) => item.hasRegister === null);
		if(itensFiltered.length <= 1)
			setDisabledLastItem(true);
		else
			setDisabledLastItem(false);
	}, [fields]);

	return (
		<>
			<RCCGrid
				container
				item
				direction="column"
				alignItems="center"
			>
				<RCCGrid
					container
					item		
				>
					<RCCGrid
						container
						item
					>
						{!occurrenceSteps ? (
							<>
								<RCCAlert 
									title={translate("Atenção")}	
									description={translate("Nenhuma etapa foi encontrada, verifique se existe alguma categoria de ocorrência selecionada")}
								/>
							</>
						) : (
							<>
								{/* Informações */}
								<RCCGrid
									container
									item
								>
									<RCCGrid 
										item
										container	
										xs={12}			
										direction="column"
										alignItems="center"
									>
										<RCCGrid
											container
											item
											xs={12}
											md={12}
											justifyContent="center"
											alignItems="center"
										>
											{/* Item */}
											{fields && fields.map((item: any, index: number) => (
												<React.Fragment key={item.id}>
													<RCCGrid
														container
														item
														xs={12}
														spacing={1}
														style={{ padding: "1rem 0" }}
													>
														<RCCGrid
															container
															item
															xs={10}
															sm={10}
															md={12}
															styleInline="@media(max-width: 959px){order: 1}"
															alignContent="center"
															style={{ fontSize: "0.9rem" }}
														>
															<b>{`${translate("Descrição")}: `}&nbsp;</b> {translate(item.oca003Descricao)}
														</RCCGrid>
														<RCCGrid
															container
															item
															xs={12}
															sm={4}
															md={4}
															justifyContent="center"
															styleInline="@media(max-width: 959px){order: 3}"
															alignContent="center"
														>
															<LovUsers 
																control={control}
																name={`octbb002[${index}].ocb002Efa005Id`}
																label={translate("Responsável")}
																error={error.octbb002 && error?.octbb002[index]?.ocb002Efa005Id}
																defaultValue={item.ocb002Efa005Id ? {
																	value: String(item.ocb002Efa005Id),
																	label: item.ocb002Efa005Nome
																} : ""}
																disabled={disabled || (!isCopy && item.hasRegister)}
																required
															/>
														</RCCGrid>
														<RCCGrid
															container
															item
															xs={disabled ? 6: 6}
															sm={disabled ? 4: 4}
															md={disabled ? 4: 3}
															justifyContent="center"
															styleInline="@media(max-width: 959px){order: 4}"
															alignContent="center"
														>
															<DateTimePicker 
																control={control}
																label={translate("Data inicial")}
																error={error.octbb002 && error?.octbb002[index]?.ocb002DataInicio}
																defaultValue={item.ocb002DataInicio ? item.ocb002DataInicio : ""}
																name={`octbb002[${index}].ocb002DataInicio`}
																type="datePicker"
																props={{
																	datePicker: {
																		disabled: disabled || (!isCopy && item.hasRegister)
																	}
																}}
															/>
														</RCCGrid>
														<RCCGrid
															container
															item
															xs={disabled ? 6: 6}
															sm={disabled ? 4: 4}
															md={disabled ? 4: 3}
															justifyContent="center"
															styleInline="@media(max-width: 959px){order: 5}"
															alignContent="center"
														>
															<DateTimePicker 
																control={control}
																label={translate("Data final")}
																defaultValue={item.ocb002DataFim ? item.ocb002DataFim : ""}
																name={`octbb002[${index}].ocb002DataFim`}
																error={error.octbb002 && error?.octbb002[index]?.ocb002DataFim}

																type="datePicker"
																props={{
																	datePicker: {
																		disabled: disabled || (!isCopy && item.hasRegister)
																	}
																}}
															/>
														</RCCGrid>

														{!disabled && (
															<RCCGrid
																container
																item
																xs={2}
																sm={2}
																md={2}
																styleInline="@media(max-width: 959px){order: 2}"
																justifyContent="center"
																alignContent="center"
															>
																<RCCTooltip
																	color="red"
																	text={translate("Excluir")}
																>
																	<RCCButton
																		color="red"
																		onClick={() => {remove(index);}}
																		disabled={fields.length <= 1 || disabled || (!isCopy && item.hasRegister) || disabledLastItem}
																		icon={{
																			name: "trash"
																		}}
																		layout="default"
																	/>
																</RCCTooltip>
															</RCCGrid>
													 )}
													
													</RCCGrid>
													<hr />
												</React.Fragment>
											))}
										</RCCGrid>
									</RCCGrid>
								</RCCGrid>
							</>
						)}
					</RCCGrid>
				</RCCGrid>
			</RCCGrid>
		</>
	);
};



export default TabSteps;
